import { Component, DestroyRef, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BatchesService } from 'src/app/services/batches.services';
import { ProductsService } from 'src/app/services/products.service';
import { AlertService } from 'src/app/services/alert.service';
import { ProductNew } from 'src/app/models/products/productNew';
import { IBatch } from 'src/app/models/batches/batch';

@Component({
    selector: 'app-product-create',
    templateUrl: './product-create.component.html',
    styleUrls: ['./product-create.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class ProductCreateComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  currentBatch!: IBatch;

  form: FormGroup = this.fb.group({
    barcode: [''],
    reference: [''],
    description: [''],
    productLink: [''],
  });

  constructor(
    private readonly productsService: ProductsService,
    private readonly batchesService: BatchesService,
    private readonly alertService: AlertService,
    private readonly fb: FormBuilder,
    public dialogRef: MatDialogRef<ProductCreateComponent>,
  ) {}

  ngOnInit(): void {
    this.currentBatch = this.batchesService.getCurrentBatch();
  }

  createProduct() {
    const newProduct = this.buildProductFromForm();
    this.productsService
      .createProduct(newProduct)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.alertService.successToast('Successfully Created Product');
          this.dialogRef.close();
        },
        error: (error) => this.handleValidationError(error),
      });
  }

  validationMessage(property: string): string | undefined {
    return this.form.get(property.toLowerCase())?.getError('serverError');
  }

  private buildProductFromForm(): ProductNew {
    const product = new ProductNew();
    product.batchId = this.currentBatch.id;
    product.barcode = this.form.get('barcode')?.value ?? '';
    product.reference = this.form.get('reference')?.value ?? '';
    product.description = this.form.get('description')?.value ?? '';
    product.productLink = this.form.get('productLink')?.value ?? '';
    return product;
  }

  private handleValidationError(error: any): void {
    if (error.status !== 422 || !error.error?.errors) return;

    const errors: Record<string, string[]> = error.error.errors;
    Object.entries(errors).forEach(([property, messages]) => {
      const control = this.form.get(property.toLowerCase());
      if (control) {
        control.markAsTouched();
        control.setErrors({ serverError: messages[0] });
      }
    });
  }
}
